import React, { Component } from "react";
import { Panel, Modal, Button } from "react-bootstrap";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { IS_UNDEFINED, IS_EMPTY_STRING, IS_VALID } from "utils";

import CrudComponent from "../zynappse-crud";
import AppThumbSchema from "./AppThumbSchema";
import saveTrail from "utils/saveTrail";
import FormContainer from "./FormContainer";

const WEB_PATH = window.__APP_CONFIG__.webPath || "http://localhost:3000";

class AppThumb extends Component {
	constructor(props) {
		super(props);

		this.refreshTableReference;

		this.refreshTable = this.refreshTable.bind(this);
		this.saveData = this.saveData.bind(this);
		this.deleteData = this.deleteData.bind(this);
		this.renderModalButton = this.renderModalButton.bind(this);
	}

	refreshTable() {
		if (
			IS_VALID(IS_VALID) &&
			typeof this.refreshTableReference === "function"
		) {
			this.refreshTableReference();
		}
	}

	saveData() {
		let { AppThumb, actions } = this.props;

		let {
			selectedData,
			formType,
			formId,

			title,
			browser,
			url,
			image,
			imageBg,
			startDate,
			endDate,
			sort,
		} = AppThumb;

		if (!IS_VALID(title) || !IS_VALID(title.trim())) {
			toast.error("Title is required.");
		} else if (!IS_VALID(browser)) {
			toast.error("Browser is required.");
		} else if (!IS_VALID(url) || !IS_VALID(url.trim())) {
			toast.error("URL is required.");
		} else if (!IS_VALID(startDate)) {
			toast.error("Start Date is required.");
		} else if (!moment(startDate, "MMM DD, YYYY hh:mm A", true).isValid()) {
			toast.error("Start Date is invalid.");
		} else if (!IS_VALID(endDate)) {
			toast.error("End Date is required.");
		} else if (!moment(endDate, "MMM DD, YYYY hh:mm A", true).isValid()) {
			toast.error("End Date is invalid.");
		} else if (!IS_VALID(sort)) {
			toast.error("Sort is required.");
		} else if (!IS_VALID(image)) {
			toast.error("Image is required.");
		} else if (!IS_VALID(imageBg)) {
			toast.error("Image Background is required.");
		} else {
			actions.setValue({
				isLoadingAction: true,
			});

			let appThumb = new Parse.Object("AppThumb");

			if (formType === "UPDATE" && selectedData) {
				appThumb = selectedData;
			}

			let data = {
				title: title.trim(),
				browser: browser.value,
				url: url.trim(),
				startDate: moment(startDate, "MMM DD, YYYY hh:mm A").toDate(),
				endDate: moment(endDate, "MMM DD, YYYY hh:mm A").toDate(),
				sort: parseInt(sort)
			};

			for (let key in data) {
				if (!IS_VALID(appThumb.get(key)) || appThumb.get(key) !== data[key]) {
					appThumb.set(key, data[key]);
				}
			}

			let dirtyKeys = appThumb.dirtyKeys();

			let changesObject = {
				objectId: appThumb.id,
			};

			for (let key of dirtyKeys) {
				changesObject[key] = IS_UNDEFINED(appThumb.get(key))
					? "unset"
					: appThumb.get(key);
			}

			Promise.all([
				new Promise((resolve) => {
					if (image && image.preview) {
						let fileNameArray = image.name.split(/\./g),
							extension = fileNameArray[fileNameArray.length - 1];

						resolve(
							new Parse.File("app_thumb." + extension, image).save() //
						);
					} else if (image && image.url && image.name) {
						resolve(
							Parse.File.fromJSON({
								name: image.name,
								url: image.url,
								__type: "File",
							})
						);
					} else {
						resolve(false);
					}
				}),
				new Promise((resolve) => {
					if (imageBg && imageBg.preview) {
						let fileNameArray = imageBg.name.split(/\./g),
							extension = fileNameArray[fileNameArray.length - 1];

						resolve(
							new Parse.File("app_thumb." + extension, imageBg).save() //
						);
					} else if (imageBg && imageBg.url && imageBg.name) {
						resolve(
							Parse.File.fromJSON({
								name: imageBg.name,
								url: imageBg.url,
								__type: "File",
							})
						);
					} else {
						resolve(false);
					}
				}),
			])
				.then(([imageObj, imageBgObj]) => {
					if (
						imageObj &&
						(!appThumb.get("image") ||
							appThumb.get("image").url() !== imageObj.url())
					) {
						appThumb.set("image", imageObj);
					}

					if (
						imageBgObj &&
						(!appThumb.get("imageBg") ||
							appThumb.get("imageBg").url() !== imageBgObj.url())
					) {
						appThumb.set("imageBg", imageBgObj);
					}

					return appThumb.save();
				})
				.then((data) => {
					changesObject.objectId = data.id;

					actions.setValue({
						isLoadingAction: false,
						showModal: false,
					});

					this.refreshTable();

					saveTrail(formType.toUpperCase(), changesObject);
				})
				.catch((err) => {
					console.log("saveData error");
					console.log(err);

					actions.setValue({
						isLoadingAction: false,
						showModal: false,
					});

					this.refreshTable();
				});
		}
	}

	deleteData() {
		let { AppThumb, actions } = this.props;

		let { selectedData, formType, formId } = AppThumb;

		actions.setValue({
			isLoadingAction: true,
		});

		selectedData
			.destroy()
			.then((data) => {
				actions.setValue({
					isLoadingAction: false,
					showModal: false,
				});

				this.refreshTable();

				saveTrail(formType.toUpperCase(), {
					objectId: selectedData.id,
					title: selectedData.get("title"),
					browser: selectedData.get("browser"),
					url: selectedData.get("url"),
					startDate: moment(selectedData.get("startDate")).format(
						"MMM DD, YYYY hh:mm A"
					),
					endDate: moment(selectedData.get("endDate")).format(
						"MMM DD, YYYY hh:mm A"
					),
					sort: selectedData.get("sort")
				});
			})
			.catch((err) => {
				console.log("deleteData error");
				console.log(err);

				actions.setValue({
					isLoadingAction: false,
					showModal: false,
				});

				this.refreshTable();
			});
	}

	renderModalButton() {
		let { AppThumb, actions } = this.props;

		let { isLoadingAction, formType } = AppThumb;
		let buttons = [],
			buttonAction = (
				name = "CREATE",
				loading = isLoadingAction,
				callback = this.saveData
			) => (
				<Button bsStyle="primary" disabled={loading} onClick={() => callback()}>
					{name}
				</Button>
			),
			buttonClose = (
				<Button
					disabled={isLoadingAction}
					onClick={() => {
						if (!isLoadingAction) {
							actions.setValue({
								showModal: false,
							});
						}
					}}
				>
					CLOSE
				</Button>
			);

		switch (formType.toUpperCase()) {
			case "CREATE":
				buttons.push(buttonAction("CREATE", isLoadingAction), buttonClose);
				break;
			case "UPDATE":
				buttons.push(buttonAction("UPDATE", isLoadingAction), buttonClose);
				break;
			case "DELETE":
				buttons.push(
					buttonAction("DELETE", isLoadingAction, this.deleteData),
					buttonClose
				);
				break;
			default:
				buttons.push(buttonClose);
				break;
		}

		return buttons;
	}

	render() {
		let { AppThumb, accessjson, actions } = this.props;

		let {
			showModal,
			isLoadingAction,
			selectedData,
			formType,
			formTitle,
			browserOptions,
		} = AppThumb;

		let crudProps = {
			schema: AppThumbSchema,
			access: accessjson.access,
			moduleQuery: [{ method: "ascending", column: "sort" }],
			saveTrail: saveTrail,
			refreshTable: (refreshTable) => {
				this.refreshTableReference = refreshTable;
			},
			customItems: [
				{
					columnName: "sort",
					render: ({value, column, getTableData, object}) => {
							let renderValue = "";
	
							if (IS_VALID(object.get('sort'))) {
									renderValue = object.get('sort');
							}
	
							return renderValue;
					}
			},
			],
			customCreate: () => {
				actions.setValue({
					showModal: true,
					formType: "CREATE",
					formTitle: "CREATE APP THUMB",
				});
			},
			customUpdate: (obj) => {
				let stateToUpdate = {
					showModal: true,
					formType: "UPDATE",
					formTitle: "UPDATE APP THUMB",
					formId: obj.id,
					selectedData: obj,
				};

				if (IS_VALID(obj.get("title"))) {
					stateToUpdate.title = obj.get("title");
				}

				if (IS_VALID(obj.get("browser"))) {
					let index = browserOptions
						.map(({ value }) => value)
						.indexOf(obj.get("browser"));

					if (index !== -1) {
						stateToUpdate.browser = browserOptions[index];
					}
				}

				if (IS_VALID(obj.get("url"))) {
					stateToUpdate.url = obj.get("url");
				}

				if (IS_VALID(obj.get("startDate"))) {
					stateToUpdate.startDate = moment(obj.get("startDate")).format('MMM DD, YYYY hh:mm A');
				}

				if (IS_VALID(obj.get("endDate"))) {
					stateToUpdate.endDate = moment(obj.get("endDate")).format('MMM DD, YYYY hh:mm A');
				}

				if (IS_VALID(obj.get("sort"))) {
					stateToUpdate.sort = obj.get("sort");
				}

				if (IS_VALID(obj.get("image"))) {
					stateToUpdate.image = {
						url: obj.get("image").url(),
						name: obj.get("image").name(),
					};
				}

				if (IS_VALID(obj.get("imageBg"))) {
					stateToUpdate.imageBg = {
						url: obj.get("imageBg").url(),
						name: obj.get("imageBg").name(),
					};
				}

				actions.setValue(stateToUpdate);
			},
			customDelete: (obj) => {
				actions.setValue({
					showModal: true,
					formType: "DELETE",
					formTitle: "DELETE APP THUMB",
					formId: obj.id,
					selectedData: obj,
				});
			},
		};

		let formContainerProps = {
			actions,

			selectedData,
			formType,
		};

		return (
			<div>
				<Panel>
					<Panel.Heading
						style={{
							backgroundColor: "#D1282F",
							color: "white",
						}}
					>
						<h4 style={{ display: "inline-block" }}>App Thumb</h4>
					</Panel.Heading>
					<Panel.Body>
						<CrudComponent {...crudProps} />
					</Panel.Body>
				</Panel>
				<Modal
					show={showModal}
					onHide={() => {
						if (!isLoadingAction) {
							actions.setValue({
								showModal: false,
							});
						}
					}}
				>
					<Modal.Header closeButton>
						<Modal.Title>{formTitle.toUpperCase()}</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<FormContainer {...formContainerProps} />
					</Modal.Body>
					<Modal.Footer>{this.renderModalButton()}</Modal.Footer>
				</Modal>
				<ToastContainer />
			</div>
		);
	}
}

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { generics } from "actions";
import { SET_APP_THUMB } from "actions/const";
import moment from "moment";
import { resolve } from "bluebird";

function mapStateToProps(state) {
	let { accessjson, AppThumb } = state;

	return {
		accessjson,
		AppThumb,
	};
}

function mapDispatchToProps(dispatch) {
	const actions = {
		setValue: (stateObject, actionType = SET_APP_THUMB) =>
			generics.setValue(actionType, stateObject),
	};

	return {
		actions: bindActionCreators(actions, dispatch),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(AppThumb);



// WEBPACK FOOTER //
// ./components/AppThumb/index.js